import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { v4 as uuidv4 } from 'uuid';
import { SnackbarState, Snack } from '../types';

export const snackbarActions: ActionTree<SnackbarState, Store> = {

  showSuccess({ commit }, payload: Snack): void {
    commit('addSnack', {
      id: uuidv4(),
      type: 'success',
      ...payload
    });
  },

  showError({ commit }, payload: Snack): void {
    commit('addSnack', {
      id: uuidv4(),
      type: 'error',
      ...payload
    });
  },

};
